// Redux/Slices/Pages/Client/countDown.js

import { createSlice } from '@reduxjs/toolkit';

const countDownSlice = createSlice({
  name: 'CountDown',
  initialState: {
    activeCountdowns: [],
    // Example structure:
    // {
    //   bookingId: '123',
    //   expiresAt: '2026-02-14T16:50:00',
    //   type: 'client_waiting' | 'provider_request' | 'client_payment' | 'provider_completion',
    //   userRole: 'client' | 'provider',
    //   metadata: { ... }
    // }
  },
  reducers: {
    addCountdown: (state, action) => {
      const { bookingId, expiresAt, type, userRole, metadata } = action.payload;
      
      // Remove existing countdown for same booking + user role
      state.activeCountdowns = state.activeCountdowns.filter(
        c => !(c.bookingId === bookingId && c.userRole === userRole)
      );
      
      // Add new countdown
      state.activeCountdowns.push({
        id: `${bookingId}-${userRole}-${type}`,
        bookingId,
        expiresAt,
        type,
        userRole,
        metadata,
        createdAt: Date.now()
      });
    },
    
    removeCountdown: (state, action) => {
      const { bookingId, userRole } = action.payload;
      state.activeCountdowns = state.activeCountdowns.filter(
        c => !(c.bookingId === bookingId && c.userRole === userRole)
      );
    },
    
    clearUserCountdowns: (state, action) => {
      const userRole = action.payload;
      state.activeCountdowns = state.activeCountdowns.filter(
        c => c.userRole !== userRole
      );
    },
    
    clearAllCountdowns: (state) => {
      state.activeCountdowns = [];
    }
  }
});

export const { 
  addCountdown, 
  removeCountdown, 
  clearUserCountdowns,
  clearAllCountdowns 
} = countDownSlice.actions;

export default countDownSlice.reducer;
